module.exports = __webpack_public_path__ + "img/thumb-fm-silouette.202f299d.jpg";